import React, { useRef, useState, useEffect } from "react";
import OfertaCard from "./OfertaCard";

const OfferSection = ({ 
  title, 
  offers, 
  user, 
  favoriteIds, 
  toggleFavorite, 
  offerLikesMap,
  onViewAll 
}) => {
  const scrollRef = useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);

  const scroll = (direction) => {
    if (scrollRef.current) {
      const { scrollLeft, clientWidth } = scrollRef.current;
      const scrollAmount = clientWidth * 0.8; // Deslocar 80% da tela visível
      const targetScroll = direction === 'left' ? scrollLeft - scrollAmount : scrollLeft + scrollAmount;
      
      scrollRef.current.scrollTo({
        left: targetScroll,
        behavior: 'smooth'
      });
    }
  };

  const checkScroll = () => {
    if (scrollRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = scrollRef.current;
      setCanScrollLeft(scrollLeft > 5);
      setCanScrollRight(scrollLeft + clientWidth < scrollWidth - 5);
    }
  };

  useEffect(() => {
    const el = scrollRef.current;
    if (el) {
      el.addEventListener('scroll', checkScroll);
      // Checagem inicial após render
      setTimeout(checkScroll, 100);
      window.addEventListener('resize', checkScroll);
      return () => {
        el.removeEventListener('scroll', checkScroll);
        window.removeEventListener('resize', checkScroll);
      };
    }
  }, [offers]);

  if (!offers || offers.length === 0) return null;

  return (
    <section className="offer-section">
      <div className="offer-section-header">
        <h2 className="offer-section-title">{title}</h2>
        {onViewAll && (
          <button 
            onClick={onViewAll}
            className="view-all-btn"
          >
            Ver tudo <i className="fas fa-chevron-right"></i>
          </button>
        )}
      </div>
      
      <div className="offer-section-carousel-container">
        {/* Navigation Arrows (Only on desktop if possible, but visible if can scroll) */}
        {canScrollLeft && (
          <button 
            className="carousel-arrow carousel-arrow-left" 
            onClick={() => scroll('left')}
            aria-label="Anterior"
          >
            <i className="fas fa-chevron-left"></i>
          </button>
        )}

        <div 
          className="offer-section-grid" 
          ref={scrollRef}
        >
          {offers.map((oferta) => (
            <OfertaCard
              key={oferta.id}
              oferta={oferta}
              user={user}
              isFavorite={favoriteIds.includes(oferta.id)}
              onFavoriteToggle={toggleFavorite}
              likes={offerLikesMap[oferta.id] || 0}
            />
          ))}

          {onViewAll && (
            <div 
              className="view-all-card" 
              onClick={onViewAll}
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: 'var(--white)',
                borderRadius: '12px',
                padding: '24px',
                cursor: 'pointer',
                textAlign: 'center',
                minWidth: '180px',
                border: '1px solid var(--border-color)',
                boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
                transition: 'all 0.2s ease',
                gap: '12px',
                flex: '0 0 180px'
              }}
            >
              <div style={{
                width: '45px',
                height: '45px',
                borderRadius: '50%',
                backgroundColor: 'rgba(52, 131, 250, 0.08)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'var(--primary-color)',
                fontSize: '18px'
              }}>
                <i className="fas fa-arrow-right"></i>
              </div>
              <span style={{ fontWeight: '700', color: 'var(--primary-color)', fontSize: '14px' }}>Ver Tudo</span>
            </div>
          )}
        </div>

        {canScrollRight && (
          <button 
            className="carousel-arrow carousel-arrow-right" 
            onClick={() => scroll('right')}
            aria-label="Próximo"
          >
            <i className="fas fa-chevron-right"></i>
          </button>
        )}
      </div>
    </section>
  );
};

export default OfferSection;
